export enum Currency {
    USD = "USD",
    EUR = "EUR",
    GBP = "GBP",
    AUD = "AUD",
    ILS = "ILS"
}

export const CurrencySign = {
    [Currency.USD]: "$",
    [Currency.EUR]: "€",
    [Currency.GBP]: "£",
    [Currency.AUD]: "A$",
    [Currency.ILS]: "₪",
}